import React, { useState, useEffect } from 'react';
import tataImg from '../images_sj/tata/tanishq1.jpg'; // Thumbnail
import arvindImg from '../images_sj/arvind/uspolo1.jpg';
import centroImg from '../images_sj/centro/centro1.jpg';
import jwelleryImg from '../images_sj/jwellery/melorra1.webp'; // Thumbnail
import './designCollection.css'; // Add this import for our new CSS

// Sample image arrays (replace with your actual images)
const tataGallery = [
  require('../images_sj/tata/tanishq1.jpg'),
  require('../images_sj/tata/tanishq2.jpg'),
  require('../images_sj/tata/titaneyeplus1.jpeg'),
  //require('../images_sj/tata/titaneyeplus2'),
  require('../images_sj/tata/fasttrack1.webp'),
  require('../images_sj/tata/fasttrack2.jpeg'),
];

const arvindGallery = [
  require('../images_sj/arvind/uspolo1.jpg'),
  require('../images_sj/arvind/uspolo2.jpg'),
  require('../images_sj/arvind/arrow1.jpg'),
  require('../images_sj/arvind/arrow2.jpg'),
  require('../images_sj/arvind/gant1.jpg'),
  require('../images_sj/arvind/gant2.webp'),
];

const centroGallery = [
  require('../images_sj/centro/centro1.jpg'),
  require('../images_sj/centro/centro2.jpg'),
];

const jwelleryGallery = [
  require('../images_sj/jwellery/melorra1.webp'),
  require('../images_sj/jwellery/starlla2.jpg'),
  require('../images_sj/jwellery/starlla3.jpg'),
  require('../images_sj/jwellery/starlla4.jpg'),
  require('../images_sj/jwellery/starlla5.jpg'),
];

const collections = [
  { name: 'TATA GROUP', image: tataImg, gallery: tataGallery },
  { name: 'ARVIND FASHIONS LTD', image: arvindImg, gallery: arvindGallery },
  { name: 'CENTRO FOOTWEAR', image: centroImg, gallery: centroGallery },
  { name: 'JWELLERY BRANDS', image: jwelleryImg, gallery: jwelleryGallery },
];

const DesignCollection = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentGallery, setCurrentGallery] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hoveredItem, setHoveredItem] = useState(null);

  const openGallery = (gallery) => {
    setCurrentGallery(gallery);
    setCurrentIndex(0);
    setShowModal(true);
    document.body.classList.add('modal-open');
  };

  // Separate function for close button click
  const handleCloseButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Close button clicked'); // Debug log
    setShowModal(false);
    document.body.classList.remove('modal-open');
  };

  // Function for modal overlay click
  const handleModalClick = (e) => {
    console.log('Modal overlay clicked'); // Debug log
    setShowModal(false);
    document.body.classList.remove('modal-open');
  };

  const prevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentIndex((prev) => 
      prev === 0 ? currentGallery.length - 1 : prev - 1
    );
  };

  const nextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentIndex((prev) => 
      prev === currentGallery.length - 1 ? 0 : prev + 1
    );
  };

  const handleContentClick = (e) => {
    e.stopPropagation(); // Prevent modal from closing when clicking on content
  };

  // ESC key handler
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && showModal) {
        setShowModal(false);
        document.body.classList.remove('modal-open');
      }
    };

    if (showModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showModal]);

  return (
    <section className="design-collection-section">
      <div className="container aboutUs-custom-top container-sm" style={{marginTop: '10px', marginBottom: '10px'}}>
        <div id="#scrolly-div" className="row add-mobile-padding">
          <div className="col-sm-6 col-md-6 mt-sm-5">
            <div className="row mt-sm-5">
              <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                <span><hr className="slash"></hr></span>
              </div>
              <div className="col-10 col-sm-11">
                <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">PORTFOLIO</p>
              </div>
            </div>
            <div className="row">
              <p className="about-sub-topic">
                <span style={{ color: '#2c3e50' }}>PRODUCT</span> 
                <span style={{ color: '#cd853f' }}> PORTFOLIO</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="design-collection-grid" style={{ marginBottom: '20px', clear: 'both' }}>
        {collections.map(({ name, image, gallery }, index) => (
          <div
            key={name}
            onClick={() => gallery.length > 0 && openGallery(gallery)}
            className={`design-collection-item ${hoveredItem === index ? 'hovered' : ''}`}
            onMouseEnter={() => setHoveredItem(index)}
            onMouseLeave={() => setHoveredItem(null)}
            onTouchStart={() => setHoveredItem(index)}
            onTouchEnd={() => setTimeout(() => setHoveredItem(null), 300)}
          >
            <img
              src={image}
              alt={name}
              className="design-collection-image"
            />
            <h3 className="design-collection-title">
              {name}
            </h3>
          </div>
        ))}
      </div>

      {/* ✅ Fixed Modal Popup */}
      {showModal && (
        <div className="design-collection-modal" onClick={handleModalClick}>
          <div className="design-collection-modal-content" onClick={handleContentClick}>
            <button 
              onClick={handleCloseButtonClick}
              onMouseDown={handleCloseButtonClick} // Add this for backup
              className="design-collection-close-btn"
              type="button"
              aria-label="Close gallery"
            >
              ×
            </button>
            <img
              src={currentGallery[currentIndex]}
              alt="Gallery"
              className="design-collection-modal-image"
            />
            <div className="design-collection-navigation">
              <button onClick={prevImage} className="design-collection-nav-btn" type="button">
                <span role="img" aria-label="Previous image">⬅️</span>
              </button>
              <button onClick={nextImage} className="design-collection-nav-btn" type="button">
                <span role="img" aria-label="Next image">➡️</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default DesignCollection;
